module.exports = __webpack_public_path__ + "static/media/testImage5.69f07356.png";